import _regeneratorRuntime from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getCartAddressFromComponents } from 'core/modules/cart/cart.utils';
import Geocode from 'react-geocode';
import { config } from 'src/config';
export function getCoords() {
  return new Promise(function (resolve, reject) {
    return navigator.permissions ? navigator.permissions.query({
      name: 'geolocation'
    }).then(function (permission) {
      return permission.state === 'granted' ? navigator.geolocation.getCurrentPosition(function (pos) {
        return resolve([pos.coords.latitude, pos.coords.longitude]);
      }) : resolve(null);
    }) : reject(null);
  });
}
export function getGeolocation() {
  return new Promise(function (resolve, reject) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        resolve([position.coords.latitude, position.coords.longitude]);
      }, function (error) {
        reject(error.message);
      }, {
        timeout: 5000
      });
    } else {
      reject('Geolocation is not available');
    }
  });
}
/**
 * Initializes geolocation
 * @param language
 * @param region
 */

export function initGeolocation(language, region) {
  Geocode.setApiKey(config.googleApiKey);
  Geocode.setLanguage(language);
  Geocode.setRegion(region);

  if (false) {
    Geocode.enableDebug();
  }
}
export function zoomToLocation(map, location, zoom) {
  if (!map) {
    return;
  }

  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    location: {
      lat: location[0],
      lng: location[1]
    }
  }, // result go from 0 to 12
  // O being the exact adress
  // 13 the country
  // we choose to zoom to the department
  function (results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      map.setCenter(results[zoom || results.length - 2].geometry.location);
      map.fitBounds(results[zoom || results.length - 2].geometry.viewport);
    }
  });
}
export function zoomToCountry(map, country) {
  if (!map) {
    return;
  }

  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    address: country
  }, function (results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      map.setCenter(results[0].geometry.location);
      map.fitBounds(results[0].geometry.viewport);
    }
  });
}
export function getAddressFromCoordinates(_x) {
  return _getAddressFromCoordinates.apply(this, arguments);
}
/**
 * Gets cart address from the address description
 * @param description Address description
 */

function _getAddressFromCoordinates() {
  _getAddressFromCoordinates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(coords) {
    var _address$results;

    var address, _address$results$0$fo, _address$results$;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Geocode.fromLatLng(coords[0].toString(), coords[1].toString());

          case 2:
            address = _context.sent;

            if (!(address !== null && address !== void 0 && (_address$results = address.results) !== null && _address$results !== void 0 && _address$results.length)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", (_address$results$0$fo = address === null || address === void 0 ? void 0 : (_address$results$ = address.results[0]) === null || _address$results$ === void 0 ? void 0 : _address$results$.formatted_address) !== null && _address$results$0$fo !== void 0 ? _address$results$0$fo : undefined);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAddressFromCoordinates.apply(this, arguments);
}

export function getCartAddressFromDescription(_x2) {
  return _getCartAddressFromDescription.apply(this, arguments);
}

function _getCartAddressFromDescription() {
  _getCartAddressFromDescription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(description) {
    var _response$results, _response$results$0$a, _response$results$, _response$results$2, _response$results$2$g;

    var response, components, location;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Geocode.fromAddress(description);

          case 2:
            response = _context2.sent;

            if (response !== null && response !== void 0 && (_response$results = response.results) !== null && _response$results !== void 0 && _response$results.length) {
              _context2.next = 5;
              break;
            }

            throw new Error('Invalid address');

          case 5:
            components = (_response$results$0$a = (_response$results$ = response.results[0]) === null || _response$results$ === void 0 ? void 0 : _response$results$.address_components) !== null && _response$results$0$a !== void 0 ? _response$results$0$a : [];
            location = (_response$results$2 = response.results[0]) === null || _response$results$2 === void 0 ? void 0 : (_response$results$2$g = _response$results$2.geometry) === null || _response$results$2$g === void 0 ? void 0 : _response$results$2$g.location;

            if (!(!components || !location)) {
              _context2.next = 9;
              break;
            }

            throw new Error('Invalid address');

          case 9:
            return _context2.abrupt("return", getCartAddressFromComponents(components, description, [location.lat, location.lng]));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCartAddressFromDescription.apply(this, arguments);
}